module.exports = __webpack_public_path__ + "static/adam_2-77cf35126db158827878a19f5b61d229.gif";